module.exports = __webpack_public_path__ + "img/seattle.074472c8.jpg";